export default "__VITE_ASSET__80d407ec__"